var exports = {
  "wx": "x234b8571--bb578b--header",
  "DD": "x234b8571--bb578b--title",
  "Mn": "x234b8571--bb578b--provider",
  "wm": "x234b8571--bb578b--logo",
  "NQ": "x234b8571--bb578b--features-list",
  "h_": "x234b8571--bb578b--description",
};

module.exports = exports;
